import React, { Fragment, useEffect, useState } from 'react';
import config from '../../config';
import { useForm, Controller } from "react-hook-form";
import { GetPropertyTypes } from '../../REST/properties';
import { BaseAxios } from '../../REST/base';
import TextField from '@mui/material/TextField';
import NativeSelect from '@mui/material/NativeSelect';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Typography from '@mui/material/Typography';
import { yupResolver } from '@hookform/resolvers/yup';
import { PayCard } from './payment';
import * as yup from "yup";
import { CreateWaitlistInvoice } from '../../REST/invoices';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import AddIcon from '@mui/icons-material/Add';
import FactIcon from '@mui/icons-material/FactCheck';
import { GetSystemSettings } from '../../REST/utilities';
import WorkflowDialogShell from '../../themes/components/WorkflowDialogShell';

export default function WaitList({ floating = false, navbar = false }) {
    const [open, setOpen] = useState(false);
    const [speedDialOpen, setSpeedDialOpen] = useState(false);
    const [showFactSheet, setShowFactSheet] = useState(false);

    useEffect(() => {
        GetSystemSettings().then((result) => {
            const setting = result.data.find((x) => x.name === 'SHOW_PROPERTY_FACTSHEET');
            if (setting) setShowFactSheet(setting.value === 'true' || setting.value === '1');
        }).catch(() => {});
    }, []);

    const factsheetUrl = `${config.REACT_APP_API_URL}/factsheet/factsheet.pdf`;

    if (floating) {
        return (
            <Box
                sx={{
                    position: 'fixed',
                    right: { xs: 16, sm: 24 },
                    bottom: { xs: 16, sm: 24 },
                    zIndex: 1400,
                }}
            >
                <SpeedDial
                    ariaLabel="Listing actions"
                    icon={<AddIcon />}
                    direction="up"
                    open={speedDialOpen}
                    onOpen={() => setSpeedDialOpen(true)}
                    onClose={() => setSpeedDialOpen(false)}
                    FabProps={{
                        color: 'primary',
                        sx: { zIndex: 1401 }
                    }}
                >
                    <SpeedDialAction
                        icon={<PersonAddAltIcon />}
                        tooltipTitle="Join WaitList"
                        onClick={() => {
                            setSpeedDialOpen(false);
                            setOpen(true);
                        }}
                        FabProps={{
                            sx: { zIndex: 1401 }
                        }}
                    />
                    {showFactSheet && (
                        <SpeedDialAction
                            icon={<FactIcon />}
                            tooltipTitle="Property Fact Sheet"
                            onClick={() => {
                                setSpeedDialOpen(false);
                                window.open(factsheetUrl, '_blank', 'noopener,noreferrer');
                            }}
                            FabProps={{ sx: { zIndex: 1401 } }}
                        />
                    )}
                </SpeedDial>
                {open && <JoinWaitList open={open} handleClose={() => setOpen(false)} />}
            </Box>
        );
    }

    const buttonStyles = navbar ? {
        variant: 'landing-login',
        sx: {}
    } : {
        variant: 'outlined'
    };

    return (
        <Fragment>
            <Button {...buttonStyles} startIcon={<PersonAddAltIcon />} onClick={() => setOpen(true)}>JOIN WAITLIST</Button>
            {showFactSheet && (
                <Button {...buttonStyles} startIcon={<FactIcon />} href={factsheetUrl} target="_blank" rel="noopener noreferrer">PROPERTY FACT SHEET</Button>
            )}
            {open && <JoinWaitList open={open} handleClose={() => setOpen(false)} />}
        </Fragment>
    );
}

function JoinWaitList({ open = false, handleClose }) {
    const isInternal = global.location.hash.indexOf("properties") !== -1;
    const [types, setTypes] = useState([]);
    const [data, setData] = useState(null);
    const [amount, setAmount] = useState(10);
    const [waitlistCount, setWaitlistCount] = useState(null);

    const schema = isInternal ? yup.object({
        propertyType: yup.string().trim().required(),
        firstName: yup.string().trim().required(),
        lastName: yup.string().trim().required(),
        phone: yup.string().trim(),
        email: yup.string().email(),
        organization: yup.string().trim(),
        aircrafttype: yup.string().trim()
    }).required() :
        yup.object({
            propertyType: yup.string().trim().required(),
            firstName: yup.string().trim().required(),
            lastName: yup.string().trim().required(),
            phone: yup.string().trim().required(),
            email: yup.string().email().required(),
            organization: yup.string().trim().required(),
            aircrafttype: yup.string().trim()
        }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: {
            propertyType: '',
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            organization: '',
            aircrafttype: ''
        },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        GetSystemSettings().then((result) => {
            const setting = result.data.find((x) => x.name === "WAITLIST_CHARGE");
            if (setting) setAmount(Number(setting.value));
        });
    }, []);

    useEffect(() => {
        (async () => {
            const result = await GetPropertyTypes();
            setTypes(result.data);
        })();
    }, []);

    useEffect(() => {
        clearErrors();
        reset();
        setData(null);
        setWaitlistCount(null);
    }, [clearErrors, reset, open]);

    const onSubmit = (result) => {
        setData(result);
    };

    const onSubmitNoPay = (formData) => {
        (async () => {
            await CreateWaitlistInvoice({}, formData);
            handleClose();
        })();
    };

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object';

    const getOptions = () => {
        return [<option key={'NA'}>Please Select</option>].concat(
            types.filter(e => e.hasWaitlist).map((e) => {
                return <option key={e._id} value={e._id} > {e.name}</option>;
            })
        );
    };

    const handlePayment = (result) => {
        (async () => {
            await CreateWaitlistInvoice(result, data);
            handleClose();
        })();
    };

    const handleSave = () => {
        if (data !== null && amount > 0) {
            handleClose();
            return;
        }

        if (amount > 0) {
            handleSubmit(onSubmit)();
            return;
        }

        handleSubmit(onSubmitNoPay)();
    };

    return (
        <WorkflowDialogShell
            open={open}
            onClose={handleClose}
            onSave={handleSave}
            title={data === null ? 'Join Waitlist' : 'Waitlist Payment'}
            saveLabel={data === null ? (amount > 0 ? 'Pay and Submit' : 'Submit') : 'Close'}
            saveDisabled={types.length === 0 && data === null}
        >
            {data === null && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Fill in your details to join the waitlist for an available property type.
                    </Typography>
                    <Controller
                        name="propertyType"
                        control={control}
                        render={({ field }) => (
                            <FormControl error={isError(errors.propertyType)} required variant='standard' fullWidth>
                                <InputLabel>Property Type</InputLabel>
                                <NativeSelect {...field} onChange={e => {
                                    field.onChange(e);
                                    const id = e.target.value;
                                    if (id && id !== 'Please Select') {
                                        setWaitlistCount(null);
                                        BaseAxios(null, null, config.REACT_APP_API_URL + '/api').get('WaitList/Count/' + id)
                                            .then(res => setWaitlistCount(res.data.count))
                                            .catch(() => setWaitlistCount(null));
                                    } else {
                                        setWaitlistCount(null);
                                    }
                                }}>{getOptions()}</NativeSelect>
                                {errors.propertyType && <FormHelperText>{errors.propertyType.message}</FormHelperText>}
                                {waitlistCount !== null && (
                                    <FormHelperText sx={{
                                        color: waitlistCount === 0 ? 'success.dark' : waitlistCount <= 3 ? 'warning.dark' : 'error.dark',
                                        fontWeight: 600,
                                        fontSize: '0.85rem'
                                    }}>
                                        {waitlistCount === 0
                                            ? 'No one on the waitlist yet — be the first!'
                                            : `${waitlistCount} ${waitlistCount === 1 ? 'person' : 'people'} currently on the waitlist`}
                                    </FormHelperText>
                                )}
                            </FormControl>
                        )}
                    />
                    <Controller name="aircrafttype" control={control} render={({ field }) => <TextField variant='standard' error={isError(errors.aircrafttype)} helperText={errors.aircrafttype && errors.aircrafttype.message} fullWidth label='Aircraft Type' {...field} />} />
                    <Controller name="firstName" control={control} render={({ field }) => <TextField variant='standard' required error={isError(errors.firstName)} helperText={errors.firstName && errors.firstName.message} fullWidth label='First Name' {...field} />} />
                    <Controller name="lastName" control={control} render={({ field }) => <TextField variant='standard' required error={isError(errors.lastName)} helperText={errors.lastName && errors.lastName.message} fullWidth label='Last Name' {...field} />} />
                    <Controller name="phone" control={control} render={({ field }) => <TextField variant='standard' required={!isInternal} error={isError(errors.phone)} helperText={errors.phone && errors.phone.message} fullWidth label='Phone' {...field} />} />
                    <Controller name="email" control={control} render={({ field }) => <TextField variant='standard' required={!isInternal} error={isError(errors.email)} helperText={errors.email && errors.email.message} fullWidth label='Email' {...field} />} />
                    <Controller name="organization" control={control} render={({ field }) => <TextField variant='standard' required={!isInternal} error={isError(errors.organization)} helperText={errors.organization && errors.organization.message} fullWidth label='Organization' {...field} />} />
                </Box>
            )}

            {data !== null && amount > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Complete the waitlist payment to finish your submission.
                    </Typography>
                    <PayCard onComplete={handlePayment} amount={amount} />
                </Box>
            )}
        </WorkflowDialogShell>
    );
}
